"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var customCheckboxStyles_1 = require("../customCheckboxStyles");
var Box_1 = require("@material-ui/core/Box");
exports.ConsentSelectorExplicit = function (_a) {
    var formData = _a.formData;
    var _b;
    var agreedValue = 'yes';
    var styles = customCheckboxStyles_1.default();
    var id = formData.id, onChange = formData.onChange, explicitConsent = formData.schema.explicitConsent;
    var _c = react_1.useState(agreedValue), consent = _c[0], setConsent = _c[1];
    var handleChange = function (e) {
        setConsent(e.target.value);
        onChange(e.target.value === agreedValue);
    };
    react_1.useEffect(function () {
        var _a;
        if (typeof ((_a = formData.schema) === null || _a === void 0 ? void 0 : _a.default) === 'boolean') {
            onChange(formData.schema.default);
        }
    }, [(_b = formData.schema) === null || _b === void 0 ? void 0 : _b.default]);
    return (<Box_1.default width={'100%'}>
      <Box_1.default className={styles.messageDisagree}>
        <core_1.Typography data-test={'consent:messageDisagree'}>
          {consent === '' && explicitConsent.messageDisagree}
        </core_1.Typography>
      </Box_1.default>
      <Box_1.default>
        <core_1.RadioGroup id={id} value={consent} onChange={handleChange}>
          <Box_1.default flex={true} flexDirection={'row'}>
            <core_1.FormControlLabel value={agreedValue} label={explicitConsent.labelAgree} control={<core_1.Radio color={'primary'} checked={consent === agreedValue} id={'consent:radio:agree'} data-test={'consent:radio:agree'} size={'small'} classes={{
        root: styles.root,
    }}/>}/>
            <core_1.FormControlLabel value={''} label={explicitConsent.labelDisagree} control={<core_1.Radio color={'primary'} checked={consent === ''} id={'consent:radio:disagree'} data-test={'consent:radio:disagree'} size={'small'} classes={{
        root: styles.root,
    }}/>}/>
          </Box_1.default>
        </core_1.RadioGroup>
      </Box_1.default>
    </Box_1.default>);
};
exports.default = exports.ConsentSelectorExplicit;
